export default "__VITE_ASSET__D9F7LeYn__"